<template>
  <v-row>
    <v-col class="py-1">
      <v-autocomplete
        v-model="selectedSupplier"
        :label="suppliersLabel"
        :items="suppliers"
        :prepend-inner-icon="compact ? null : supplierTypeIcon"
        item-text="itemText"
        item-value="supplierId"
        clearable
        :search-input.sync="supplierSearch"
        @keyup.enter="onUnpricedSupplier"
        class="mr-2"
        :outlined="outlinedInputs"
        :loading="loading"
        :disabled="loading"
        hide-details
      >
        <template v-slot:prepend-item>
          <v-list-item
            v-if="supplierSearch != '' && supplierSearch != undefined"
          >
            <v-list-item-content>
              <v-list-item-title>
                Press
                <kbd @click="onUnpricedSupplier">enter</kbd> to add unpriced
                item: " <strong>{{ supplierSearch }}</strong
                >"
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item="data">
          <v-list-item-avatar>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-img
                  v-on="on"
                  :src="
                    data.item.service && data.item.service.imageURL != ''
                      ? data.item.service.imageURL
                      : data.item.supplier
                      ? data.item.supplier.imageURL
                      : null
                  "
                ></v-img>
              </template>
              <v-container style="max-width: 500px">
                <v-row>
                  <v-col cols="12">
                    <v-img
                      contain
                      :src="
                        data.item.service && data.item.service.imageURL != ''
                          ? data.item.service.imageURL
                          : data.item.supplier.imageURL
                      "
                    ></v-img>
                  </v-col>
                  <v-col cols="12">
                    <div v-html="data.item.supplier.description"></div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tooltip>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle
              v-html="`${data.item.supplierName} (${data.item.supplier.code})`"
            ></v-list-item-subtitle>
            <v-list-item-title
              v-html="
                `${data.item.serviceName} (Price from: ${data.item.priceFrom}${data.item.priceFromCurrencyCode} ${data.item.rateTypeCode})`
              "
            ></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              small
              text
              icon
              color="indigo"
              @click.native.stop="$emit('supplier-edit', data.item)"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small>mdi-pencil</v-icon>
                </template>
                Edit {{ data.item.supplierName }}
              </v-tooltip>
            </v-btn>
          </v-list-item-action>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col class="py-1">
      <v-autocomplete
        v-model="selectedService"
        :items="services"
        :label="servicesLabel"
        item-text="itemText"
        item-value="serviceId"
        append-outer-icon="mdi-table-merge-cells"
        @click:append-outer="$emit('merge')"
        @change="onServiceChange"
        :search-input.sync="serviceSearch"
        @keyup.enter="onUnpricedService"
        :outlined="outlinedInputs"
        :loading="loading"
        :disabled="loading"
        hide-details
      >
        <template v-slot:prepend-item>
          <v-list-item
            v-if="
              serviceSearch != '' &&
              serviceSearch != undefined &&
              selectedSupplier
            "
          >
            <v-list-item-content>
              <v-list-item-title>
                Press
                <kbd @click="onUnpricedService">enter</kbd> to add unpriced
                item: " <strong>{{ serviceSearch }}</strong
                >"
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title
              v-html="
                `${data.item.serviceName} (Price from: ${data.item.priceFrom}${data.item.priceFromCurrencyCode} ${data.item.rateTypeCode})`
              "
            ></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn small text icon color="indigo">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey lighten-1"
                    >mdi-information</v-icon
                  >
                </template>
                <item-prices-grid
                  :items="[...data.item.prices]"
                ></item-prices-grid>
              </v-tooltip>
            </v-btn>
          </v-list-item-action>
        </template>
      </v-autocomplete>
      <div v-if="debug">
        <code>selected service: {{ selectedService }}</code>
        <code>{{ services }}</code>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { uniqueByProp } from "../../../../helpers/index";
import ItemPricesGrid from "./ItineraryBuilderItemQuickAddItemPricesGrid";
export default {
  name: "item-quick-add-split-search",
  props: {
    supplierTypeIcon: {
      type: String,
      default: () => "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    compact: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    editedItem: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    ItemPricesGrid,
  },

  data() {
    return {
      debug: false,
      selectedSupplier: this.editedItem ? this.editedItem.supplierId : null,
      supplierSearch: "",
      selectedService: this.editedItem ? this.editedItem.serviceId : null,
      serviceSearch: "",
      searchTimeout: null,
      searchDebounceTime: 700,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    suppliers() {
      return this.items.length
        ? uniqueByProp(this.items, "supplierId").map((item) => ({
            ...item,
            itemText: `${item.supplierName} (${
              item.supplier ? item.supplier.code : ""
            })`,
          }))
        : [];
    },
    suppliersLabel() {
      return this.suppliers.length
        ? `Select Supplier (${this.suppliers.length} results)`
        : "No Results";
    },
    services() {
      return this.selectedSupplier
        ? this.items
            .filter((item) => item.supplierId == this.selectedSupplier)
            .map((item) => ({
              ...item,
              itemText: `${item.serviceName} (${item.service.code}) - Price from: ${item.priceFrom}${item.priceFromCurrencyCode} ${item.rateTypeCode}`,
            }))
        : [];
    },
    servicesLabel() {
      return this.services.length
        ? `Select Service (${this.services.length} results)`
        : "No Results";
    },
  },

  watch: {
    supplierSearch(newVal) {
      clearTimeout(this.searchTimeout);
      if (!this.selectedSupplier) {
        this.searchTimeout = setTimeout(() => {
          this.$emit("supplier-search-input", newVal);
        }, this.searchDebounceTime);
      }
    },
    editedItem(newItem) {
      this.selectedSupplier = newItem.supplierId;
    },
  },

  methods: {
    onServiceChange(event) {
      this.$nextTick(() => {
        this.selectedSupplier = null;
      });
      const item = this.services.find((item) => item.serviceId == event);
      if (item) {
        this.$emit("input", item.id);
      }
    },
    onUnpricedSupplier() {
      this.$emit("unpriced-supplier", this.supplierSearch);
    },
    onUnpricedService() {
      const supplier = this.suppliers.find(
        (s) => (s.id = this.selectedSupplier)
      );
      this.$emit("unpriced-service", {
        serviceName: this.serviceSearch,
        supplier,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemQuickAddSplitSearch.vue